import { render, staticRenderFns } from "./ReviewPeriodsList.vue?vue&type=template&id=1fda9fde"
import script from "./ReviewPeriodsList.vue?vue&type=script&lang=js"
export * from "./ReviewPeriodsList.vue?vue&type=script&lang=js"
import style0 from "./ReviewPeriodsList.vue?vue&type=style&index=0&id=1fda9fde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports